export const extensionFromString = (filename: string): string =>
  filename.split('.').pop()?.toLowerCase();
